var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"free-registration"},[_c('transition',{attrs:{"name":"expand","mode":"out-in"}},[_c(_vm.curComponent,{tag:"component",attrs:{"title":_vm.title,"description":_vm.description,"register-for-mvp":""},on:{"success":_vm.goForward,"back":_vm.goBack}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }